// lib/ui.js
// 4s, not 2: Studio (browser), backend (eu-west-1) and instances can now sit in
// three different regions (multi-region fallback, IR-171) — each poll cycle is
// 2 requests/cam across two ocean-grade hops, and 2s left no headroom: queued
// requests blew the deadline and painted healthy boxes red for a cycle.
export const POLL_MS = 4000;

export const confirmDanger = (msg) => window.confirm(msg);
export const shortLabel = (s, n = 80) =>
  (s || '').replace(/\s+/g, ' ').trim().slice(0, n) + ((s||'').length > n ? '…' : '');

export const styles = {
  wrapper: {
    margin: 0,
    padding: 30,
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    maxWidth: '100%',
    background: '#23243a',
    color: '#fff',
    borderRadius: 24,
    boxShadow: '0 4px 24px rgba(0, 0, 0, 0.3)',
    border: '1px solid #555',
    marginBottom: 24
  },
  row: { display:'flex', alignItems:'center', gap:12, marginBottom:16 },
  btn: (bg) => ({
    backgroundColor: bg || '#9333ea',
    color:'#fff',
    border:'none',
    borderRadius: 12,
    padding:'12px 24px',
    cursor:'pointer',
    width: 'auto',
    minWidth: 140,
    fontWeight: 600,
    fontSize: 16,
    boxShadow: '0 4px 12px rgba(147, 51, 234, 0.3)',
    transition: 'all 0.3s ease'
  }),
  badge: (bg) => ({
    display:'inline-block',
    padding:'6px 12px',
    borderRadius:16,
    color:'#fff',
    fontWeight:'600',
    backgroundColor: bg || '#9333ea',
    marginRight:8,
    fontSize: 14
  }),
  log: {
    background:'#181828',
    border:'2px solid #555',
    borderRadius: 12,
    padding: 14,
    whiteSpace:'pre-wrap',
    marginTop:16,
    fontFamily:'monospace',
    fontSize:'14px',
    color: '#e0e0e0'
  },
};
